var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import MeetingDetailDisplay from "./meetingDetailDisplay";
import MeetingWithDisplay from "./meetingWithDisplay";
import Confirm from "../shared/confirm";
import ErrorService from "../../src/Services/Shared/Error.service";
import MeetingService from "../../src/Services/Meeting.service";
import { getXSRF } from "../../src/Services/Shared/FetchService";
class MeetingDetail extends Component {
    constructor() {
        // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
        super();
        // @ts-expect-error - TS2416 - Property 'state' in type 'MeetingDetail' is not assignable to the same property in base type 'Component<Props, State, any>'.
        this.state = {
            meetingId: null,
            meeting: null,
            isCancelling: false,
            isCancelled: false,
            cancelErrors: [],
        };
        this.onCancelClick = this.onCancelClick.bind(this);
    }
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        this.setState({
            meetingId: parseInt(this.props.match.params.id, 10),
        }, this.getMeeting);
    }
    getMeeting() {
        return __awaiter(this, void 0, void 0, function* () {
            // @ts-expect-error - TS2345 - Argument of type 'null' is not assignable to parameter of type 'number'.
            const meeting = yield MeetingService.getMeeting(this.state.meetingId);
            this.setState({
                meeting,
                isCancelled: meeting.cancelled,
            });
        });
    }
    onCancelClick() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setState({ isCancelling: true });
            try {
                yield fetch(`/aviso/calendar/cancel?meetingId=${this.state.meetingId}`, {
                    credentials: "include",
                    headers: {
                        "X-XSRF-TOKEN": getXSRF(),
                    },
                });
                this.setState({ isCancelled: true });
            }
            catch (all) {
                this.setState({
                    cancelErrors: [
                        ...this.state.cancelErrors,
                        ErrorService.getMessageFromError(all),
                    ],
                });
            }
            finally {
                this.setState({ isCancelling: false });
            }
        });
    }
    render() {
        return (_jsxs("div", { children: [this.state.meeting && (_jsxs("div", { children: [_jsx(MeetingWithDisplay, { meetingWith: this.state.meeting.staff }), _jsx(MeetingDetailDisplay
                        // @ts-expect-error - TS2740 - Type '{ name: any; }' is missing the following properties from type 'MeetingType': id, additionalInfo, durationMinutes, requiresLocation, and 6 more. | TS2339 - Property 'meetingTypeName' does not exist on type 'never'.
                        , { 
                            // @ts-expect-error - TS2740 - Type '{ name: any; }' is missing the following properties from type 'MeetingType': id, additionalInfo, durationMinutes, requiresLocation, and 6 more. | TS2339 - Property 'meetingTypeName' does not exist on type 'never'.
                            meetingType: { name: this.state.meeting.meetingTypeName }, 
                            // @ts-expect-error - TS2339 - Property 'startTime' does not exist on type 'never'.
                            startTime: this.state.meeting.startTime, 
                            // @ts-expect-error - TS2339 - Property 'endTime' does not exist on type 'never'.
                            endTime: this.state.meeting.endTime, 
                            // @ts-expect-error - TS2339 - Property 'duration' does not exist on type 'never'.
                            durationMinutes: this.state.meeting.duration, 
                            // @ts-expect-error - TS2339 - Property 'serviceDeliveryLocation' does not exist on type 'never'.
                            location: this.state.meeting.serviceDeliveryLocation, topic: 
                            // @ts-expect-error - TS2339 - Property 'serviceOfferings' does not exist on type 'never'.
                            this.state.meeting.serviceOfferings
                                ? // @ts-expect-error - TS2339 - Property 'serviceOfferings' does not exist on type 'never'.
                                    this.state.meeting.serviceOfferings[0]
                                : null, 
                            // @ts-expect-error - TS2339 - Property 'studentQuestion' does not exist on type 'never'.
                            comment: this.state.meeting.studentQuestion, allowCommentEdit: false })] })), _jsxs("div", { className: "my-3", children: [!this.state.isCancelled && (_jsx("div", { children: _jsxs("button", { type: "button", className: "btn btn-danger btn-lg", "data-toggle": "modal", "data-target": "#confirmCancelDialog", children: [_jsx("span", { className: "fa fa-times", "aria-hidden": "true" }), " Cancel Meeting"] }) })), this.state.isCancelled && (_jsxs("div", { children: [_jsxs("div", { className: "alert alert-warning", children: [_jsx("span", { className: "fa fa-exclamation-triangle", "aria-hidden": "true" }), " ", "This meeting has been cancelled."] }), _jsx("div", { className: "my-3", children: _jsx("a", { href: "/aviso/student/home", children: "Back to Home" }) })] }))] }), _jsx(Confirm, { id: "confirmCancelDialog", errors: this.state.cancelErrors, showSuccessMessage: this.state.isCancelled, successMessage: "Your meeting has been cancelled.", confirmButtonText: "Cancel", confirmButtonCssClass: "btn-danger", confirmButtonIcon: "fa-times", onConfirm: this.onCancelClick, isLoading: this.state.isCancelling, title: "Cancel Meeting", children: "Are you sure you want to cancel this meeting? This cannot be undone." })] }));
    }
}
export default MeetingDetail;
